import React from 'react';

const BoardIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.3335 15V5C8.3335 4.22343 8.3335 3.83515 8.20663 3.52886C8.03747 3.12048 7.71302 2.79602 7.30464 2.62687C6.99835 2.5 6.61007 2.5 5.8335 2.5C5.05693 2.5 4.66864 2.5 4.36236 2.62687C3.95398 2.79602 3.62952 3.12048 3.46036 3.52886C3.3335 3.83515 3.3335 4.22343 3.3335 5V15C3.3335 15.7766 3.3335 16.1649 3.46036 16.4711C3.62952 16.8795 3.95398 17.204 4.36236 17.3731C4.66864 17.5 5.05693 17.5 5.8335 17.5C6.61007 17.5 6.99835 17.5 7.30464 17.3731C7.71302 17.204 8.03747 16.8795 8.20663 16.4711C8.3335 16.1649 8.3335 15.7766 8.3335 15Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.6668 11.6667V5C16.6668 4.22343 16.6668 3.83515 16.54 3.52886C16.3708 3.12048 16.0463 2.79602 15.638 2.62687C15.3317 2.5 14.9434 2.5 14.1668 2.5C13.3903 2.5 13.002 2.5 12.6957 2.62687C12.2873 2.79602 11.9629 3.12048 11.7937 3.52886C11.6668 3.83515 11.6668 4.22343 11.6668 5V11.6667C11.6668 12.4432 11.6668 12.8315 11.7937 13.1378C11.9629 13.5462 12.2873 13.8706 12.6957 14.0398C13.002 14.1667 13.3903 14.1667 14.1668 14.1667C14.9434 14.1667 15.3317 14.1667 15.638 14.0398C16.0463 13.8706 16.3708 13.5462 16.54 13.1378C16.6668 12.8315 16.6668 12.4432 16.6668 11.6667Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default BoardIcon;
